
import React from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { fetchAbout } from "../../../features/aboutSlice/aboutSlice";

const CompanyStartUp = () => {
  const about = useSelector((state) => state.about);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchAbout());
  }, []);

  return (
    <div className="max-w mx-auto">
      <div className="">
        <div className="grid w-full place-content-center">
        <h2 className="sub-title-style text-center !font-Yatra mt-10">
      कार्यलयको स्थापना
      </h2>
      <div className="bg-primary-blue mx-auto mt-1 h-1 w-32 rounded-full" />

{
  about.data?.filter((value)=>value.title==="कार्यलयको स्थापना").map((item,i)=>{
    return(
      <div key={i} className="max-w-[800px] px-5 text-center">
     
      {/* image  */}
      <div className="mt-10 h-[50vh]">
        <img
         src={item.image}
          alt=""
          className="border-primary-blue h-full w-full rounded-tr-[60px] rounded-bl-[60px] border-4 object-cover"
        />
      </div>
      {/* text  */}
      <div className="font-Laila mt-10 text-primary-blue md:px-5">
        {item.description}
        {/* <p className="text-primary-blue text-sm leading-10 lg:!text-lg">
          हजुरको व्यवसायको आवश्यकता अनुसारको सेवा पाउदिनकि भन्ने चिन्ता अब
          नलिनुहोस, कानुनी खातासंग आबद्द भयसंगै हजुरको एक दक्ष तथा अनुभबी
          Expert assign हुनुहुनेछ जसले हजुरलाई सम्पर्क गरि प्रतक्ष्य रुपमा
          हजुरको आवश्यकता/समस्या बुझी सोहि अनुरुप सल्लाह/सुझाब दिई चाहिने
          सेवाको बृस्तृत जानकारी समेत दिनुहुनेछ | हजुरले आफ्नो अनुकुलता
          अनुसार हाम्रो Expert संग प्रतक्ष्य कुरा गरी आफ्नो आवश्यकता पुरा
          गर्न सक्नुहुने छ |
        </p>
        <p className="text-primary-blue mt-3 text-sm leading-10 lg:!text-lg">
          हजुरको व्यवसायको आवश्यकता अनुसारको सेवा पाउदिनकि भन्ने चिन्ता अब
          नलिनुहोस, कानुनी खातासंग आबद्द भयसंगै हजुरको एक दक्ष तथा अनुभबी
          Expert assign हुनुहुनेछ जसले हजुरलाई सम्पर्क गरि प्रतक्ष्य रुपमा
          हजुरको आवश्यकता/समस्या बुझी सोहि अनुरुप सल्लाह/सुझाब दिई चाहिने
          सेवाको बृस्तृत जानकारी समेत दिनुहुनेछ | हजुरले आफ्नो अनुकुलता
          अनुसार हाम्रो Expert संग प्रतक्ष्य कुरा गरी आफ्नो आवश्यकता पुरा
          गर्न सक्नुहुने छ |
        </p>
        <p className="text-primary-blue mt-3 text-sm leading-10 lg:!text-lg">
          हजुरको व्यवसायको आवश्यकता अनुसारको सेवा पाउदिनकि भन्ने चिन्ता अब
          नलिनुहोस, कानुनी खातासंग आबद्द भयसंगै हजुरको एक दक्ष तथा अनुभबी
          Expert assign हुनुहुनेछ जसले हजुरलाई सम्पर्क गरि प्रतक्ष्य रुपमा
          हजुरको आवश्यकता/समस्या बुझी सोहि अनुरुप सल्लाह/सुझाब दिई चाहिने
          सेवाको बृस्तृत जानकारी समेत दिनुहुनेछ | हजुरले आफ्नो अनुकुलता
          अनुसार हाम्रो Expert संग प्रतक्ष्य कुरा गरी आफ्नो आवश्यकता पुरा
          गर्न सक्नुहुने छ |
        </p> */}
      </div>
    </div>
    )
  })
}

          {/* <div className="max-w-[800px] px-5 text-center">
            <h2 className="sub-title-style !font-Yatra mt-10">
              कर्यालय स्थापना परिचया
            </h2>
            <div className="bg-primary-blue mx-auto mt-1 h-1 w-32 rounded-full" />
            <div className="mt-10 h-[50vh]">
              <img
                src="https://images.unsplash.com/photo-1646764578980-65dbce171e7b?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=881&q=80"
                alt=""
                className="border-primary-blue h-full w-full rounded-tr-[60px] rounded-bl-[60px] border-4 object-cover"
              />
            </div>
            <div className="font-Laila mt-10 md:px-5">
              <p className="text-primary-blue text-sm leading-10 lg:!text-lg">
                हजुरको व्यवसायको आवश्यकता अनुसारको सेवा पाउदिनकि भन्ने चिन्ता अब
                नलिनुहोस, कानुनी खातासंग आबद्द भयसंगै हजुरको एक दक्ष तथा अनुभबी
                Expert assign हुनुहुनेछ जसले हजुरलाई सम्पर्क गरि प्रतक्ष्य रुपमा
                हजुरको आवश्यकता/समस्या बुझी सोहि अनुरुप सल्लाह/सुझाब दिई चाहिने
                सेवाको बृस्तृत जानकारी समेत दिनुहुनेछ | हजुरले आफ्नो अनुकुलता
                अनुसार हाम्रो Expert संग प्रतक्ष्य कुरा गरी आफ्नो आवश्यकता पुरा
                गर्न सक्नुहुने छ |
              </p>
              <p className="text-primary-blue mt-3 text-sm leading-10 lg:!text-lg">
                हजुरको व्यवसायको आवश्यकता अनुसारको सेवा पाउदिनकि भन्ने चिन्ता अब
                नलिनुहोस, कानुनी खातासंग आबद्द भयसंगै हजुरको एक दक्ष तथा अनुभबी
                Expert assign हुनुहुनेछ जसले हजुरलाई सम्पर्क गरि प्रतक्ष्य रुपमा
                हजुरको आवश्यकता/समस्या बुझी सोहि अनुरुप सल्लाह/सुझाब दिई चाहिने
                सेवाको बृस्तृत जानकारी समेत दिनुहुनेछ | हजुरले आफ्नो अनुकुलता
                अनुसार हाम्रो Expert संग प्रतक्ष्य कुरा गरी आफ्नो आवश्यकता पुरा
                गर्न सक्नुहुने छ |
              </p>
              <p className="text-primary-blue mt-3 text-sm leading-10 lg:!text-lg">
                हजुरको व्यवसायको आवश्यकता अनुसारको सेवा पाउदिनकि भन्ने चिन्ता अब
                नलिनुहोस, कानुनी खातासंग आबद्द भयसंगै हजुरको एक दक्ष तथा अनुभबी
                Expert assign हुनुहुनेछ जसले हजुरलाई सम्पर्क गरि प्रतक्ष्य रुपमा
                हजुरको आवश्यकता/समस्या बुझी सोहि अनुरुप सल्लाह/सुझाब दिई चाहिने
                सेवाको बृस्तृत जानकारी समेत दिनुहुनेछ | हजुरले आफ्नो अनुकुलता
                अनुसार हाम्रो Expert संग प्रतक्ष्य कुरा गरी आफ्नो आवश्यकता पुरा
                गर्न सक्नुहुने छ |
              </p>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default CompanyStartUp;
